import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93b0161e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottomjumbo" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "services",
    class: "section-title services"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Our services"),
    /*#__PURE__*/_createElementVNode("p", null, "for your proxy needs")
  ])
], -1))
const _hoisted_5 = { class: "row serviceusecases" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-title services" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Our proxy services"),
    /*#__PURE__*/_createElementVNode("p", null, "for all your needs")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn",
    href: "#services"
  }, "Start now")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-title services clients" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "What our clients say"),
    /*#__PURE__*/_createElementVNode("img", {
      alt: "section-shape",
      src: "https://cdn.proxyscrape.com/img/section-shape.png"
    })
  ])
], -1))

import Hero from '@/components/home/Hero.vue';
import OurServices from '@/components/home/OurServices.vue';
import ServicesDetail from '@/components/home/ServicesDetail.vue';
import UseCases from '@/components/shared/UseCases.vue';
import ClientReviews from '@/components/shared/ClientReviews.vue';
import BlogSection from '@/components/shared/BlogSection.vue';
import BannerSection from '@/components/shared/BannerSection.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Hero),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(OurServices),
          _createVNode(ServicesDetail),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(UseCases),
            _hoisted_7
          ]),
          _hoisted_8,
          _createVNode(ClientReviews),
          _createVNode(BlogSection),
          _createVNode(BannerSection)
        ])
      ])
    ])
  ]))
}
}

})